'use client';
import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useState,
} from 'react';
import {Direction} from '@mui/material';
import {ThemeMode} from '../types';

export interface ThemeSettingsState {
  mode: ThemeMode;
  direction?: Direction;

  setMode(mode: ThemeMode): void;
}

export const ThemeSettingsContext = createContext<ThemeSettingsState>(null!);

export const ThemeSettingsProvider = ({children}: PropsWithChildren) => {
  const setMode = useCallback((mode: ThemeMode) => {
    setState(state => ({
      ...state,
      mode,
    }));
  }, []);

  const [state, setState] = useState<ThemeSettingsState>({
    mode: 'light',
    setMode,
  });

  return (
    <ThemeSettingsContext.Provider value={state}>
      {children}
    </ThemeSettingsContext.Provider>
  );
};
